module.exports = __webpack_public_path__ + "img/calendar-2.d0c8f3d3.svg";